import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const HelpSupportPageLayer = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 15;

  useEffect(() => {
    const fetchHelpRequests = async () => {
      const token = localStorage.getItem("adminToken");

      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/help-support/all`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await res.json();
        if (res.ok) {
          setRequests(data);
        } else {
          setError(data.message || "Failed to load data.");
        }
      } catch (err) {
        setError("An error occurred while fetching data.");
      } finally {
        setLoading(false);
      }
    };

    fetchHelpRequests();
  }, []);

  const totalPages = Math.ceil(requests.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentUsers = requests.slice(indexOfFirstRecord, indexOfLastRecord);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="card radius-16 mt-24">
      <div className="card-body">
        {/* Button to open popup form*/}
        {/* <div className="d-flex align-items-center flex-wrap gap-1 justify-content-end mb-20">
          <button
            className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-sm btn-sm px-8 py-6"
            onClick={handleExportToExcel}
          >
            <Icon icon="ph:arrow-up" className="icon text-md" />
            Export
          </button>
        </div> */}

        {/* Popup Form */}
        {/* {isOpen && <PopupForm onClose={() => setIsOpen(false)} />} */}
        {requests.length === 0 ? (
          <div className="text-center py-5">
            <h4>No records found</h4>
            <p>There are no forms to display at the moment.</p>
          </div>
        ) : (
          <div className="table-responsive scroll-md">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  {/* <th>Logo</th> */}
                  <th className="text-center">Date</th>
                  <th className="text-center">Company ID</th>
                  <th className="text-center">Company Name</th>
                  <th className="text-center">Company Email</th>
                  <th className="text-center">Company MobileNo.</th>
                  <th className="text-center">Type</th>
                  <th className="text-center">Description</th>
                </tr>
              </thead>
              <tbody>
                {currentUsers.map((user, index) => (
  <tr key={index}>
    <td className="text-center">
      {new Date(user.createdAt).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      })}
    </td>
    <td className="text-center">
      {user?.adminId?.cid ?? "N/A"}
    </td>
    <td className="text-center">
      {user?.adminId?.name ?? "N/A"}
    </td>
    <td className="text-center">
      {user?.adminId?.email ?? "N/A"}
    </td>
    <td className="text-center">
      {user?.adminId?.cmobile ? `+91 ${user.adminId.cmobile}` : "N/A"}
    </td>
    <td className="text-center">
      {user?.type ?? "N/A"}
    </td>
    <td className="text-center">
      {user?.description ?? "N/A"}
    </td>
  </tr>
))}

              </tbody>
            </table>
          </div>
        )}

        {requests.length > 0 && (
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
            <span>
              Showing {indexOfFirstRecord + 1} to{" "}
              {Math.min(indexOfLastRecord, requests.length)} of{" "}
              {requests.length} entries
            </span>
            <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <Icon icon="ep:d-arrow-left" />
                </button>
              </li>
              {[...Array(totalPages).keys()].map((num) => (
                <li className="page-item" key={num + 1}>
                  <button
                    className={`page-link ${
                      currentPage === num + 1
                        ? "bg-primary-600 text-white"
                        : "bg-neutral-200 text-secondary-light"
                    } fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md`}
                    onClick={() => handlePageChange(num + 1)}
                  >
                    {num + 1}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <Icon icon="ep:d-arrow-right" />
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpSupportPageLayer;
